<template></template>

<script setup>
import { onMounted, defineProps, reactive } from "vue";

onMounted(() => {
    if (window.ReactNativeWebView) {
        window.handleVerifyPurchase = (message) => {
            console.log({ message });
            const msg = JSON.parse(message);
            switch (msg.platform) {
                case "android":
                    axios.post("/google-payment/verify", msg).then((res) => {
                        if (res?.data?.forwardUrl) {
                            window.location.href = res.data.forwardUrl;
                        } else {
                            window.location.reload();
                        }
                    });
                    break;
                case "ios":
                case "macos":
                    axios.post("/apple-payment/verify", msg).then((res) => {
                        if (res?.data?.forwardUrl) {
                            window.location.href = res.data.forwardUrl;
                        } else {
                            window.location.reload();
                        }
                    });
            }
            return true;
        };
    }
});
</script>

<style scoped></style>
